
<div class="loading-indicator">
    <spinner class="spinner--small" />
</div>
